import PageComponent from '../base/PageComponent';

export default class PropertyCarouselPopup extends PageComponent
{
    constructor(index) {
        super();
        this.index = index;
    }

    init() {
        this.show();
        //this.onWindowResize();
        $('.popup-overlay').on('click', e => this.onOverlayClick(e));
    }

    //onWindowResize(){
    //    this.popupPosition();
    //}

    show() {
        let slider = $('.property-detail__slideshow-popup').clone();
        var index = this.index;

        slider.popup({
            popupHTML: '<div class="popup property"><div class="popup-content"></div></div>',
            overlayHTML: '<div class="popup-overlay image-modal-overlay"><div class="close-popup icon-close" title="Close"></div></div>',
            fadeIn: false,
            onShow:function(){
                setTimeout(function(){
                    $('.property-detail__slideshow-popup .property-detail__slides').slick({
                        initialSlide: index,
                        slide: '.property-detail__slideshow-popup .slide__item',
                        asNavFor: '.property-detail__slideshow-popup .property-detail__thumbnails-inner',
                        autoplay: false,
                        adaptiveHeight: false,
                        dots: false,
                        infinite: true,
                        arrows: false,
                        centerMode: true,
                        centerPadding: '0',
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        focusOnSelect: true
                    });
                }, 5);

                $('.property-detail__slideshow-popup .property-detail__thumbnails-inner').slick({
                    initialSlide: index,
                    slidesToShow: 6,
                    asNavFor: '.property-detail__slideshow-popup .property-detail__slides',
                    dots: false,
                    centerMode: false,
                    focusOnSelect: true,
                    infinite: true,
                    centerPadding: '0',
                    prevArrow: '<div class="icon-arrow-top arrow-prev"></div>',
                    nextArrow: '<div class="icon-arrow-top arrow-next"></div>',
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 5
                            }
                        },
                        {
                            breakpoint: 460,
                            settings: {
                                slidesToShow: 4
                            }
                        }
                    ]
                });

                // Close Button
                //this.popup.find('.close-popup').on('click', function (e) {
                //    e.preventDefault();
                //    self.popup.hide();
                //    self.close();
                //    $('.property-detail__slideshow-popup .property-detail__slides').slick('unslick');
                //    $('.property-detail__slideshow-popup .property-detail__thumbnails-inner').slick('unslick');
                //});
            }
        });

    }

    popupPosition(){
        var windowHeight = $(window).height();

        setTimeout(function(){
            var popup = $('.popup.property'),
                popupHeight = popup.height(),
                popupOffset = popupHeight / 2,
                windowOffset = windowHeight/2;

            popup.css('top', windowOffset - popupOffset);
        }, 100);
    }



    onOverlayClick(e){
        setTimeout(function(){
            $('.property-detail__slideshow-popup .property-detail__slides').slick('unslick');
            $('.property-detail__slideshow-popup .property-detail__thumbnails-inner').slick('unslick');
        }, 500);
    }

}


// WEBPACK FOOTER //
// ./javascript/modules/PropertyCarouselPopup.js